import React, { useState } from "react";
import LOGO from "../../assets/images/DERMASTER_NEW_LOGO.png";
import TextField from "../../components/textfield/textfield";
import Button from "../../components/button/Button";
import "../../assets/styles/fogotpassword.scss";
import MainButton from "../../components/button/mainButton";
import { Row, Col, Alert, message, Form, Input, Checkbox } from "antd";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";

const ForgotPassword = () => {
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);

  const onFinish = async (values: any) => {
    console.log("values =>", values);

    const { email } = values;

    if (!email) {
      message.warning("กรุณาป้อนอีเมล!");
      return;
    }

    try {
      setLoading(true);

      const body = { ...values };

      const { data }: any = await axios.put(
        `/users/recover/forgot-password`,
        body
      );
      console.log("data =>", data);

      message.success("ระบบส่งข้อมูลสำเร็จ โปรดตรวจสอบอีเมลของคุณ!");

      setTimeout(() => {
        console.log("go to opd...");
        history.push(`/forgotpassword/sendEmail?email=${email}`);
      }, 1000);
    } catch (err: any) {
      message.warning("ไม่พบอีเมลผู้ใช้นี้ในระบบ กรุณาตรวจสอบใหม่อีกครั้ง!");
      setLoading(false);
    }
  };

  return (
    <div className="login">
      <div className="container">
        <img className="logo" src={LOGO} alt="Dermaster" />
        <div className="box">
          <div className="box-contant">
            <Form
              name="normal_login"
              className="login-form"
              layout="vertical"
              initialValues={{ remember: true }}
              onFinish={onFinish}
            >
              <label className="label1">
                ป้อนที่อยู่อีเมลของคุณเพื่อรีเซ็ตรหัสผ่านของคุณ
              </label>
              <label className="label2">
                Enter your email address to reset your password
              </label>
              <TextField name="email" placeholder="Email" width={300} />
              <div style={{ marginTop: "10px" }}></div>
              <MainButton
                title="SEND"
                to="/forgotpassword/sendEmail"
                width="320px"
                background="#5BAEA9"
                isSubmit={true}
                loading={loading}
              />
              <div className="forgot-password">
                {/* <label>ลืมรหัสผ่าน?/Forgot password?</label> */}
                <Link to="/">Back to log in</Link>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ForgotPassword;
